import { WindowWithDataLayer } from '@/interfaces/data-layer.interface'
import User from '@interfaces/user.interface'
import UserHelper from './user.helper'

export default class DataLayerHelper {
  private initialized = false
  private initializationPromise: Promise<void>
  window: WindowWithDataLayer = window
  user: User
  userHelper = new UserHelper()

  constructor() {
    this.initializationPromise = this.initialize()
  }

  async initialize() {
    if (this.initialized) {
      return
    }

    try {
      this.user = await this.userHelper.getUser()
      this.initialized = true
    } catch (error) {
      console.error('Failed to initialize DataLayerHelper', error)
    }
  }

  private async ensureInitialized() {
    await this.initializationPromise
  }

  public async sendErrorToDataLayer({ errorCode, socialNetwork }) {
    await this.ensureInitialized()
    const dataLayer = {
      event: 'connection_social_network',
      socialNetworkName: socialNetwork,
      return: 'error',
      description: errorCode?.code,
      user: {
        id: this.user?.squidId ?? null,
      },
    }
    this.window.dataLayer.push(dataLayer)
  }

  public async sendSuccessToDataLayer({ socialNetwork }) {
    await this.ensureInitialized()
    const dataLayer = {
      event: 'connection_social_network',
      socialNetworkName: socialNetwork,
      return: 'success',
      user: {
        id: this.user?.squidId ?? null,
      },
    }
    this.window?.dataLayer?.push(dataLayer)
  }

  public async sendToDataLayer(payload) {
    await this.ensureInitialized()
    this.pushToDataLayer(payload)
  }

  private pushToDataLayer(payload) {
    const fullPayload = {
      ...payload,
      user: {
        ...(payload.user ?? {}),
        id: payload.user?.id ?? payload.user?.squidId ?? this.user?.squidId ?? null,
      },
    }
    this.window?.dataLayer?.push(fullPayload)
  }
}
